import React from 'react';
import { HistoryTableHeader, HistoryTableHeaderItem } from './styledComponents';
import { TEXT_KEY, getText } from 'shared/utils/localization';

const HistoryListHeader = ({ displayDetailsColumn }) => {
  return (
    <HistoryTableHeader>
      {[
        { key: TEXT_KEY.OFFER },
        { key: TEXT_KEY.STATUS },
        { key: TEXT_KEY.REDEMPTION_DATE },
        { key: '', condition: displayDetailsColumn },
      ].map(
        ({ key, condition }, index) =>
          condition !== false && (
            <HistoryTableHeaderItem customWidth={index === 0 ? 35 : null} key={index}>
              {getText(key)}
            </HistoryTableHeaderItem>
          )
      )}
    </HistoryTableHeader>
  );
};

export default HistoryListHeader;

